import {createTheme, responsiveFontSizes} from '@mui/material/styles';

/***Colors***/

const primaryTextColor   = "#777777";
const secondaryTextColor = "#E5E5EB";
const primaryMainColor   = "#AF0000";
const primaryLightColor  = "#87c5e2";

/***Sizes***/
const borderRadius = 4;

const theme = createTheme({

    breakpoints:{
        keys:['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 768,
            md: 992,
            lg: 1200,
            xl: 1600
        }
    },
    palette: {
      
        primary: {
            main: primaryMainColor,
            light:primaryLightColor,
        },
        secondary: {
            main: primaryTextColor,
            light:secondaryTextColor
        }
    },
   
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2:{
            textAlign:"center",
            fontSize:"35px",
            color:primaryTextColor,
            fontWeight:"bold"
        },
        h5:{
            fontSize: 24,
        },
        subtitle2:{
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {
     
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
               tooltip:{
                borderRadius:3
               }
            },
        },
    },
});

const nextBetTheme = createTheme({
    palette: {
      primary: {
        main: '#003c79 ', 
      },
      secondary: {
        main: '#777',
        light:"#ffe000" 
      },
    },
    shape: {
        borderRadius: borderRadius
    },
    typography: {
        fontSize: 14,
        htmlFontSize: 16,
        h2:{
            textAlign:"center",
            fontSize:"35px",
            color:primaryTextColor,
            fontWeight:"bold"
        },
        h5:{
            fontSize: 24,
        },
        subtitle2:{
            fontWeight: 700,
        },
        fontFamily: [
            'Arial',
            'Roboto',
            'sans-serif',
            'Open Sans',
            '"Segoe UI"',
            '"Segoe UI Emoji"',
            '"Segoe UI Symbol"',
            '"Helvetica Neue"',
            '"Apple Color Emoji"',
        ].join(','),
    },

    components: {
     
        MuiFormControl: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiInputAdornment: {
            styleOverrides: {
                root: {
                    height: 'auto'
                }
            }
        },
        MuiTooltip: {
            styleOverrides: {
               tooltip:{
                borderRadius:3
               }
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    "&.restartSession":{
                        "&:hover":{
                            color:"#003c79"
                        }
                    }
                }
            }  
        }
    }
  });
  export const defaultTheme = responsiveFontSizes(theme);
  export const nextBetThemeWithFonts = responsiveFontSizes(nextBetTheme);